import * as THREE from "three";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { CONFIG } from "../config";
import { BodyType } from "@bennara/shared";

export type ModelLoadCallback = (model: THREE.Group) => void;
export type ModelErrorCallback = (error: unknown) => void;

export class ModelLoader {
  private readonly loader = new GLTFLoader();

  load(
    bodyType: BodyType,
    onLoad: ModelLoadCallback,
    onError?: ModelErrorCallback,
  ): void {
    this.loader.load(
      CONFIG.models[bodyType],
      (gltf) => {
        const model = gltf.scene;
        model.traverse((child) => {
          if (child instanceof THREE.Mesh) {
            child.castShadow = true;
            child.receiveShadow = true;
          }
        });
        this._centerAndScale(model);
        onLoad(model);
      },
      undefined,
      (error) => {
        console.error("ModelLoader: Failed to load model", error);
        onError?.(error);
      },
    );
  }

  private _centerAndScale(model: THREE.Group): void {
    const box = new THREE.Box3().setFromObject(model);
    const center = box.getCenter(new THREE.Vector3());
    const size = box.getSize(new THREE.Vector3());
    const maxDim = Math.max(size.x, size.y, size.z);
    const scale = CONFIG.scene.modelScale / maxDim;
    model.scale.setScalar(scale);
    model.position.sub(center.multiplyScalar(scale));
  }
}
